import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRevalidator, useRouteError } from 'react-router-dom';

import { getObservabilityContext, reportBrowserError } from '@/observability';
import { isKycRouteError } from '@/routes/kycError';

import { ErrorScreen, ErrorView } from './ErrorPage';

export default function KycErrorPage() {
  // error screens render outside <Suspense>, so they must not wait for a translation file
  const { t } = useTranslation(undefined, { useSuspense: false });
  const error = useRouteError();
  const revalidator = useRevalidator();
  const kycError = isKycRouteError(error) ? error : undefined;

  useEffect(() => {
    if (kycError) reportBrowserError('route', kycError, { routeArea: 'onboarding' });
  }, [kycError]);

  if (!kycError) return <ErrorView error={error} source='route' />;

  const reference = getObservabilityContext().correlationId;
  if (kycError.code === 'invalid-link') {
    return (
      <ErrorScreen
        message={t('Return to Alphie Trader to start onboarding again or request a new link.')}
        reference={reference}
        showHome
        title={t('This onboarding link is invalid or has expired')}
      />
    );
  }

  return (
    <ErrorScreen
      actionDisabled={revalidator.state === 'loading'}
      actionLabel={revalidator.state === 'loading' ? t('Retrying…') : t('Retry')}
      message={t('Check your connection and try again.')}
      onAction={() => revalidator.revalidate()}
      reference={reference}
      showHome
      title={t('Unable to load onboarding')}
    />
  );
}
